import { GlIcon, GlButton, GlCollapsibleListbox, GlTooltipDirective as GlTooltip } from '@gitlab/ui';
import { debounce } from 'lodash-es';
import { __ } from '~/locale';
import { DEFAULT_DEBOUNCE_AND_THROTTLE_MS } from '~/lib/utils/constants';
import axios from '~/lib/utils/axios_utils';
export default {
    name: 'IssuableMoveDropdown',
    components: {
        GlIcon,
        GlButton,
        GlCollapsibleListbox
    },
    directives: {
        GlTooltip
    },
    props: {
        projectsFetchPath: {
            type: String,
            required: true
        },
        dropdownButtonTitle: {
            type: String,
            required: true
        },
        moveInProgress: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'dropdown-close',
        'move-issuable',
        'toggle-collapse'
    ],
    data () {
        return {
            projects: [],
            projectsList: [],
            selectedProjects: [],
            noResultsText: '',
            isSearching: false
        };
    },
    mounted () {
        this.fetchProjects = debounce(this.fetchProjects, DEFAULT_DEBOUNCE_AND_THROTTLE_MS);
    },
    methods: {
        triggerSearch () {
            this.$refs.dropdown.search();
        },
        async fetchProjects (search = '') {
            this.isSearching = true;
            try {
                const { data } = await axios.get(this.projectsFetchPath, {
                    params: {
                        search
                    }
                });
                this.projects = data;
                this.projectsList = data.map((item)=>({
                        value: item.id,
                        text: item.name_with_namespace
                    }));
                if (!this.projectsList.length) {
                    this.noResultsText = __('No matching results');
                }
            } catch (e) {
                this.noResultsText = __('Failed to load projects');
            } finally{
                this.isSearching = false;
            }
        },
        handleProjectSelect (items) {
            // hack: simulate a single select to prevent the dropdown from closing
            // todo: switch back to single select when https://gitlab.com/gitlab-org/gitlab-services/design.gitlab.com/-/issues/2476 is fixed
            this.selectedProjects = [
                items[items.length - 1]
            ];
        },
        handleMoveClick () {
            this.$refs.dropdown.close();
            this.$emit('move-issuable', this.projects.find((item)=>item.id === this.selectedProjects[0]));
        },
        handleDropdownHide () {
            this.$emit('dropdown-close');
        }
    }
};
